import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { isHrOrItAdminDept } from "src/app/constants/departments";
@Injectable({
  providedIn: "root",
})
export class InventoryService {
  private adminRequestCount = new BehaviorSubject<number>(0);
  adminRequestCount$ = this.adminRequestCount.asObservable();

  updateAdminRequestCount(count: number) {
    this.adminRequestCount.next(count);
  }
  constructor(private httpClient: HttpClient) { }

  exportInventoryBarcodes(ids: string[]): Observable<Blob> {
    return this.httpClient.post(this.new_inventory_url + "/barcodes/export", { ids }, { responseType: "blob" });
  }

  exportWorkstationBarcodes(ids: string[]): Observable<Blob> {
    return this.httpClient.post(this.new_workstation_url + "/barcodes/export", { ids }, { responseType: "blob" });
  }

  new_inventory_url = environment.host + "inventory";
  get_inv_users = environment.host + "users";
  new_workstation_url = environment.host + "workstation";
  request_action_url = environment.host + "request/";
  user_inv_action_url = environment.host + "user-inventory/";
  get_admin_req_url = environment.host + "admin-request";
  admin_all_action_url = this.get_admin_req_url + "/take-action";
  bulk_upload_url = this.new_inventory_url + "/bulk-upload";
  notification_url = environment.host + "notification";

  uploadInventory(formData: FormData) {
    return this.httpClient.post(this.bulk_upload_url, formData);
  }

  getInvUsers(userName: string = ""): Observable<any> {
    return this.httpClient.get<any>(this.get_inv_users, {
      params: {
        userName
      }
    });
  }


  addInventory(inventoryData: FormData): Observable<any> {
    return this.httpClient.post(this.new_inventory_url, inventoryData);
  }

  updateInventory(inventoryData: FormData): Observable<any> {
    return this.httpClient.patch(this.new_inventory_url, inventoryData);
  }
  updateWorkstation(id, inventoryData: any): Observable<any> {
    return this.httpClient.patch(
      this.new_workstation_url + "/" + id,
      inventoryData,
    );
  }
  removeWorkstationAssignee(body) {
    return this.httpClient.patch(
      this.new_workstation_url + "/remove-assignee",
      body,
    );
  }

  uploadFiles(fileFormData: FormData, id) {
    return this.httpClient.post(
      this.new_workstation_url + "/add-image" + "/" + id,
      fileFormData,
    );
  }

  getAllInventory(field: any) {
    const page = field.pageNum || field.page || 1;
    const limit = field.limit || 50;
    let get_inventory_url = `${environment.host}inventory?page=${page}&limit=${limit}`;
    if (field.available !== undefined && field.available !== null) {
      get_inventory_url += `&available=${field.available}`;
    }
    if (field.searchQuery && field.searchQuery !== undefined) {
      get_inventory_url += `&searchQuery=${encodeURIComponent(field.searchQuery)}`;
    }
    if (field.type && field.type !== undefined) {
      get_inventory_url += `&type=${field.type}`;
    }
    if (field.assignedTo) {
      get_inventory_url += `&assignedTo=${encodeURIComponent(field.assignedTo)}`;
    }
    if (field.sortBy) {
      get_inventory_url += `&sortBy=${field.sortBy}`;
    }
    if (field.sortOrder) {
      get_inventory_url += `&sortOrder=${field.sortOrder}`;
    }
    console.log("Calling API:", get_inventory_url);
    return this.httpClient.get(get_inventory_url);
  }

  globalNotication(field) {
    const notification_url =
      environment.host +
      "notification" +
      "/" +
      `?page=${field.page}&limit=${field.limit}`;
    return this.httpClient.get(notification_url);
  }

  getInventoryById(id) {
    return this.httpClient.get(this.new_inventory_url + "/" + id);
  }
  getWorkstationById(id) {
    return this.httpClient.get(this.new_workstation_url + "/" + id);
  }
  deleteInventory(id) {
    return this.httpClient.delete(this.new_inventory_url + "/" + id);
  }

  deleteAssignedInv(id) {
    return this.httpClient.delete(this.user_inv_action_url + id);
  }
  getSearchedInventory(field: any) {
    const page = field.pageNum || field.page || 1;
    const limit = field.limit || 50;
    let get_search_inv_url = `${environment.host}inventory?page=${page}&limit=${limit}`;
    if (field.available !== undefined && field.available !== null) {
      get_search_inv_url += `&available=${field.available}`;
    }
    if (field.searchQuery && field.searchQuery !== undefined) {
      get_search_inv_url += `&searchQuery=${encodeURIComponent(field.searchQuery)}`;
    }
    if (field.assignedTo) {
      get_search_inv_url += `&assignedTo=${encodeURIComponent(field.assignedTo)}`;
    }
    if (field.sortBy) {
      get_search_inv_url += `&sortBy=${field.sortBy}`;
    }
    if (field.sortOrder) {
      get_search_inv_url += `&sortOrder=${field.sortOrder}`;
    }
    return this.httpClient.get(get_search_inv_url);
  }
  getSearchedServiceModalInventory(field) {
    const get_search_inv_url =
      environment.host +
      "user-inventory/assign?" +
      `${field.searchQuery && field.searchQuery !== undefined
        ? `&searchQuery=${field.searchQuery}`
        : ""
      }&page=${field.pageNum}&limit=${field.limit}`;
    return this.httpClient.get(get_search_inv_url);
  }

  getSearchedWorkstation(field: any) {
    const page = field.page || field.pageNum || 1;
    const limit = field.limit || 50;
    let get_search_inv_url = `${environment.host}workstation?page=${page}&limit=${limit}`;
    if (field.searchQuery) {
      get_search_inv_url += `&searchQuery=${encodeURIComponent(field.searchQuery)}`;
    }
    if (field.filter) {
      get_search_inv_url += `&filter=${field.filter}`;
    }
    if (field.sortBy) {
      get_search_inv_url += `&sortBy=${field.sortBy}`;
    }
    if (field.sortOrder) {
      get_search_inv_url += `&sortOrder=${field.sortOrder}`;
    }
    return this.httpClient.get(get_search_inv_url);
  }

  addWorkstation(workstationData: FormData): Observable<any> {
    return this.httpClient.post(this.new_workstation_url, workstationData);
  }

  getWorkstation(field: any) {
    const page = field.page || field.pageNum || 1;
    const limit = field.limit || 50;
    let get_workstation_url = `${environment.host}workstation?page=${page}&limit=${limit}`;
    if (field.searchQuery) {
      get_workstation_url += `&searchQuery=${encodeURIComponent(field.searchQuery)}`;
    } else if (field.name) {
      get_workstation_url += `&searchQuery=${encodeURIComponent(field.name)}`;
    }
    if (field.filter) {
      get_workstation_url += `&filter=${field.filter}`;
    }
    if (field.assignedTo) {
      get_workstation_url += `&assignedTo=${encodeURIComponent(field.assignedTo)}`;
    }
    if (field.sortBy) {
      get_workstation_url += `&sortBy=${field.sortBy}`;
    }
    if (field.sortOrder) {
      get_workstation_url += `&sortOrder=${field.sortOrder}`;
    }
    return this.httpClient.get(get_workstation_url);
  }

  deleteWorkstation(id) {
    return this.httpClient.delete(this.new_workstation_url + "/" + id);
  }
  newInventoryRequest(newData: any) {
    return this.httpClient.post(
      this.request_action_url + "new-inventory",
      newData,
    );
  }

  getNewInventoryRequest(field: any) {
    const userDepartment = localStorage.getItem("department");
    const isAllQuery =
      field.isAll || isHrOrItAdminDept(userDepartment) ? `&isAll=true` : "";
    const statusQuery = field.status ? `&status=${field.status}` : "";
    const searchQuery = field.searchQuery
      ? `&searchQuery=${field.searchQuery}`
      : "";

    const url = `${this.request_action_url}new-inventory?page=${field.pageNum}&limit=${field.limit}${statusQuery}${isAllQuery}${searchQuery}`;
    return this.httpClient.get(url);
  }

  addInventoryRequest(invData: any) {
    return this.httpClient.post(this.request_action_url + "inventory", invData);
  }

  getAllInventoryRequest(field: any) {
    const userDepartment = localStorage.getItem("department");
    const isAllQuery =
      field.isAll || isHrOrItAdminDept(userDepartment) ? `&isAll=true` : "";
    const statusQuery = field.status ? `&status=${field.status}` : "";
    const searchQuery = field.searchQuery
      ? `&searchQuery=${field.searchQuery}`
      : "";

    const url = `${this.request_action_url}inventory?page=${field.pageNum}&limit=${field.limit}${searchQuery}${statusQuery}${isAllQuery}`;
    return this.httpClient.get(url);
  }

  forwardRequest(forwardData: any) {
    return this.httpClient.post(
      this.request_action_url + "forward/new-inventory",
      forwardData,
    );
  }
  assignInv(assignData: any) {
    return this.httpClient.post(
      this.user_inv_action_url + "assign",
      assignData,
    );
  }

  getAssignInv(field: any) {
    const userDepartment = localStorage.getItem("department");
    let assigned_url = `${environment.host}user-inventory/assign?page=${field.pageNum}&limit=${field.limit}`;

    if (field.searchQuery) {
      assigned_url += `&searchQuery=${encodeURIComponent(field.searchQuery)}`;
    }

    if (field.status) {
      assigned_url += `&status=${field.status}`;
    }

    if (field.assignedTo) {
      assigned_url += `&assignedTo=${encodeURIComponent(field.assignedTo)}`;
    }

    if (field.sortBy) {
      assigned_url += `&sortBy=${field.sortBy}`;
    }

    if (field.sortOrder) {
      assigned_url += `&sortOrder=${field.sortOrder}`;
    }

    return this.httpClient.get(assigned_url);
  }

  getAssigned(field: any) {
    let assigned_url = `${this.new_inventory_url}/assigned?page=${field.pageNum}&limit=${field.limit}`;
    if (field.assignedTo) {
      assigned_url += `&assignedTo=${encodeURIComponent(field.assignedTo)}`;
    }
    if (field.searchQuery) {
      assigned_url += `&searchQuery=${encodeURIComponent(field.searchQuery)}`;
    }
    if (field.sortBy) {
      assigned_url += `&sortBy=${field.sortBy}`;
    }
    if (field.sortOrder) {
      assigned_url += `&sortOrder=${field.sortOrder}`;
    }
    return this.httpClient.get(assigned_url);
  }

  addServiceRequest(serviceData: any) {
    return this.httpClient.post(
      this.request_action_url + "service",
      serviceData,
    );
  }

  getServiceRequest(field: any) {
    const userDepartment = localStorage.getItem("department");
    const isAllQuery =
      field.isAll || isHrOrItAdminDept(userDepartment) ? `&isAll=true` : "";
    const statusQuery = field.status ? `&status=${field.status}` : "";
    const searchQuery = field.searchQuery
      ? `&searchQuery=${field.searchQuery}`
      : "";

    const url = `${this.request_action_url}service?page=${field.pageNum}&limit=${field.limit}${searchQuery}${statusQuery}${isAllQuery}`;
    return this.httpClient.get(url);
  }

  addForwardServiceReq(forwardData: any) {
    return this.httpClient.post(
      this.request_action_url + "forward/service",
      forwardData,
    );
  }

  getAllForwardedReq(reqData: any) {
    return this.httpClient.post(`${this.request_action_url}forward`, reqData);
  }

  addAssignedReturn(returnData: any) {
    return this.httpClient.post(this.request_action_url + "return", returnData);
  }

  addApprovedImages(returnData: any) {
    return this.httpClient.post(
      this.user_inv_action_url + "submit-image",
      returnData,
    );
  }

  assignedExtendRequest(extendData: any) {
    return this.httpClient.post(
      this.user_inv_action_url + "extend-request",
      extendData,
    );
  }

  adminAction(approvedData: any) {
    return this.httpClient.post(
      this.request_action_url + "take-action",
      approvedData,
    );
  }

  deleteAction(deleteData: any) {
    return this.httpClient.patch(
      this.request_action_url + "delete-request",
      deleteData,
    );
  }

  superAdminAction(approvedData: any) {
    return this.httpClient.post(
      this.get_admin_req_url + "/" + "take-action",
      approvedData,
    );
  }
  getPendingRequest(pendingData: any) {
    return this.httpClient.post(
      `${this.user_inv_action_url}pending-request`,
      pendingData,
    );
  }

  getApprovedRequest(approvedData: any) {
    const userDepartment = localStorage.getItem("department");
    let payload = approvedData;
    if (isHrOrItAdminDept(userDepartment) && payload && payload.isAll === undefined) {
      payload = { ...payload, isAll: "true" };
    }
    return this.httpClient.post(
      `${this.user_inv_action_url}approved-request`,
      payload,
    );
  }

  getHrApprovedRequest(approvedData: any) {
    const userDepartment = localStorage.getItem("department");
    let payload = approvedData;
    if (isHrOrItAdminDept(userDepartment) && payload && payload.isAll === undefined) {
      payload = { ...payload, isAll: "true" };
    }
    return this.httpClient.post(
      `${this.user_inv_action_url}approved-request`,
      payload,
    );
  }

  getDeclinedRequest(declinedData: any, field: any) {
    return this.httpClient.post(
      `${this.user_inv_action_url}declined-request?page=${field.pageNum}&limit=${field.limit}`,
      declinedData,
    );
  }
  getOverdueAssets(field: any) {
    let overdue_asset_url = `${environment.host}user-inventory/overdue-asset?page=${field.pageNum}&limit=${field.limit}`;
    return this.httpClient.get(overdue_asset_url);
  }
  getInvReturnRequest(field: any) {
    const userDepartment = localStorage.getItem("department");

    const statusQuery = field.status ? `&status=${field.status}` : "";
    const isAllQuery =
      field.isAll || isHrOrItAdminDept(userDepartment) ? `&isAll=true` : "";
    const searchQuery = field.searchQuery
      ? `&searchQuery=${field.searchQuery}`
      : "";
    return this.httpClient.get(
      `${this.request_action_url}return?page=${field.pageNum}&limit=${field.limit}${statusQuery}${isAllQuery}${searchQuery}`,
    );
  }
  getHRInvReturnRequest(field: any) {
    const userDepartment = localStorage.getItem("department");

    const statusQuery = field.status ? `&status=${field.status}` : "";
    const isAllQuery =
      field.isAll || isHrOrItAdminDept(userDepartment) ? `&isAll=true` : "";
    const searchQuery = field.searchQuery
      ? `&searchQuery=${field.searchQuery}`
      : "";

    return this.httpClient.get(
      `${this.request_action_url}return?page=${field.pageNum}&limit=${field.limit}${statusQuery}${isAllQuery}${searchQuery}`,
    );
  }

  getHROwnReturnRequest(field: any) {
    const searchQuery = field.searchQuery
      ? `&searchQuery=${field.searchQuery}`
      : "";
    return this.httpClient.get(
      `${this.request_action_url}return?page=${field.pageNum}&limit=${field.limit}${searchQuery}`,
    );
  }

  overdueExtendRequest(extendData: any) {
    return this.httpClient.post(
      this.user_inv_action_url + "extend",
      extendData,
    );
  }

  getExtendRequest(field: any) {
    const userDepartment = localStorage.getItem("department");
    let url = `${this.request_action_url}extend?`;

    if (field.searchQuery) {
      url += `searchQuery=${field.searchQuery}&`;
    }

    url += `page=${field.pageNum}&limit=${field.limit}`;

    if (field.status) {
      url += `&status=${field.status}`;
    }

    if (field.isAll || isHrOrItAdminDept(userDepartment)) {
      url += `&isAll=true`;
    }

    return this.httpClient.get(url);
  }

  getInventoryOverview() {
    return this.httpClient.get(this.new_inventory_url + "/overview");
  }

  getAllCounts() {
    return this.httpClient.get(this.user_inv_action_url + "request-count");
  }
  getAssetReturnRequest(field: any) {
    let get_asset_return_url = `${environment.host}user-inventory/return-request?page=${field.pageNum}&limit=${field.limit}`;
    return this.httpClient.get(get_asset_return_url);
  }
  getAdminRequest(adminReqData: any) {
    return this.httpClient.post(this.get_admin_req_url, adminReqData);
  }
  deleteInventoryImage(body: any) {
    return this.httpClient.patch(
      this.new_inventory_url + "/delete-inventory-image",
      body,
    );
  }
  deleteWorkstationImage(id, body: any) {
    return this.httpClient.post(
      this.new_workstation_url + "/remove-image/" + id,
      body,
    );
  }

  getNotificationCount() {
    return this.httpClient.get(this.notification_url + "/count");
  }
}
